'use client'
import type { ReactNode, ButtonHTMLAttributes, InputHTMLAttributes,
  SelectHTMLAttributes, TextareaHTMLAttributes } from 'react'
import { createContext, useContext, useEffect, useId, useRef, useState } from 'react'
import { cx } from '../utils'

// ── Field ──

export function Field({
  label,
  hint,
  required,
  children,
}: {
  label: string
  hint?: ReactNode
  required?: boolean
  children: ReactNode
}) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className="flex items-baseline justify-between gap-3">
        <span className="text-[13px] font-medium tracking-[0.08em] text-ink-2 uppercase">
          {label}
          {required && <span className="text-danger"> *</span>}
        </span>
        {hint && <span className="font-mono text-[13px] text-ink-3">{hint}</span>}
      </span>
      {children}
    </label>
  )
}
